<div class="mt-5 container-fluid d-flex justify-content-center text-center" [style]="{'height': flexHeight}">
    <div class="box">
      <div class="mb-2">
        <!-- <app-svg-icon 
        *ngIf="failed"
        class="mt-3 justify-content-center text-center"
        [src]="'../../../../assets/SVGIcons/uploadesuccess.svg'"
        ></app-svg-icon> -->
        <app-svg
         iconType="UploadeSuccess"  
         *ngIf="failed"
         class="mt-3 justify-content-center text-center" >                        
        </app-svg>
                
        <!-- <app-svg-icon 
        *ngIf="!failed"
        class="mt-3 justify-content-center text-center"
        [src]="'../../../../assets/SVGIcons/uploadFaild.svg'"
        ></app-svg-icon> -->
        <app-svg
         iconType="UploadFaild"  
         *ngIf="!failed"
         class="mt-3 justify-content-center text-center" >                        
        </app-svg>
      </div>
      <div *ngIf="failed" class="font-15 text-semi-primary mb-2">{{data?.importData?.fileName ?? 'Filename.xlsx'}}</div>
      <div  *ngIf="failed" class="font-15 text-gray mb-4">Import was completed successfully.</div>    
      <div  *ngIf="!failed" class="font-15 text-gray mb-3">Import could not be completed. Please try again.</div>    
      <div *ngIf="failed" class="font-13 mb-1 text-light-gray">Added Records: {{data?.addedRecords ??'0'}}</div>
      <div *ngIf="failed" class="font-13 mb-4 text-light-gray">Excluded Records: {{data?.excludedRecords ?? '0'}}</div>
      <div>
        <app-button 
        [button_2]="true"
        [buttonClass]="'button button-primary mt-1'"
        [buttonLable]="enumButtonName.NEW_IMPORT"
        (click)="onClick()"
      >
      </app-button>
      </div>
       <div class="col-12 d-flex align-item-center p-t-15 ">
      <button class="col-6 text-secondary-color link font-12 my-1 border-0 bg-transparent" (click)="downloadExel('Error')">Download Error Report </button>
      <button class="col-6 text-secondary-color link font-12 my-1 border-0 bg-transparent" (click)="downloadExel('Success')">Download Import Summery</button>
    </div>
  </div>